import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { HttpClientModule } from '@angular/common/http';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { TimeSinceModule } from '@fgb/portal-component-library/src/lib/shared/time-since';
import { RouterModule } from '@angular/router';
import { NotificationHubComponent } from './notification-hub/notification-hub.component';
import { NotificationItemComponent } from './notification-center/notification-item/notification-item.component';
import { NotificationToastComponent } from './notification-center/notification-toast/notification-toast.component';
import { NotificationCenterToastComponent } from './notification-center/toast/notification-center-toast';
import { NotificationGroupItemComponent } from './notification-management/notification-group-item/notification-group-item.component';
import { NotificationManagementComponent } from './notification-management/notification-management.component';
import { WebpushNotificationButtonsComponent } from './webpush-notification-buttons/webpush-notification-buttons.component';

@NgModule({
  declarations: [
    NotificationHubComponent,
    NotificationItemComponent,
    NotificationToastComponent,
    NotificationCenterToastComponent,
    NotificationGroupItemComponent,
    NotificationManagementComponent,
    WebpushNotificationButtonsComponent,
  ],
  imports: [
    TimeSinceModule,
    CommonModule,
    FormsModule,
    PipesModule,
    ReactiveFormsModule,
    InlineSVGModule,
    HttpClientModule,
    RouterModule,
    FGBSharedModule
  ],
  exports: [
    NotificationHubComponent,
    NotificationItemComponent,
    NotificationToastComponent,
    NotificationCenterToastComponent,
    NotificationGroupItemComponent,
    NotificationManagementComponent,
    WebpushNotificationButtonsComponent,
  ],
})
export class NotificationModule {}
